/**
 * Copyright © Veeam Software Group GmbH.
 */

export enum LocationMode {
    UseDefaultLocation = 1,
    UseLocationClaim = 2,
}
